import { PublicKey } from "@solana/web3.js";
import { Metaplex } from "@metaplex-foundation/js";

export const tokenDetailsMetaplex = async (connection, mintAddress) => {
  const metaplex = Metaplex.make(connection);
  try {
      const mintPublicKey = new PublicKey(mintAddress);

      // Fetch metadata for the token/NFT
      const nft = await metaplex.nfts().findByMint({ mintAddress: mintPublicKey });

      if (!nft || !nft.uri) {
          throw new Error("Failed to fetch NFT metadata or URI is missing.");
      }

      const metadataUri = nft.uri;

      // Fetch and parse the metadata JSON
      const response = await fetch(metadataUri);
      if (!response.ok) {
          throw new Error(`Failed to fetch metadata JSON from URI: ${metadataUri}`);
      }

      const metadataJson = await response.json();

      // Validate and extract the token's icon/image
      const tokenIcon = metadataJson.image;
      if (!tokenIcon || typeof tokenIcon !== "string") {
          throw new Error(`Invalid token image URL: ${tokenIcon}`);
      }

      return {
          name: nft.name,
          symbol: nft.symbol,
          decimals: nft.mint.decimals,
          logo: tokenIcon,
      };
  } catch (error) {
      //console.error("Error fetching token metadata:", error.message);
      return null;
  }
};
